import React from 'react';
import { required } from '../../util/validators';
import { FieldSelect } from '../../components';
import { OnChange } from 'react-final-form-listeners';

import css from './EditListingDescriptionForm.css';

const CustomCategorySelectFieldMaybe = props => {
  const { name, id, categories, subCategories, intl, values, form } = props;
  const categoryLabel = intl.formatMessage({
    id: 'EditListingDescriptionForm.categoryLabel',
  });
  const categoryPlaceholder = intl.formatMessage({
    id: 'EditListingDescriptionForm.categoryPlaceholder',
  });
  const categoryRequired = required(
    intl.formatMessage({
      id: 'EditListingDescriptionForm.categoryRequired',
    })
  );

  const subCategoryLabel = intl.formatMessage({
    id: 'EditListingDescriptionForm.subCategoryLabel',
  });
  const subCategoryPlaceholder = intl.formatMessage({
    id: 'EditListingDescriptionForm.subCategoryPlaceholder',
  });
  const subCategoryRequired = required(
    intl.formatMessage({
      id: 'EditListingDescriptionForm.subCategoryRequired',
    })
  );

  const { category: categoryVal } = values;

  return categories ? (
    <>
      <FieldSelect
        className={css.category}
        name={name}
        id={id}
        label={categoryLabel}
        validate={categoryRequired}
      >
        <option disabled value="">
          {categoryPlaceholder}
        </option>
        {categories.map(c => (
          <option key={c.key} value={c.key}>
            {intl.formatMessage({ id: c.labelId })}
          </option>
        ))}
      </FieldSelect>

      <OnChange name={name}>
        {(newVal, oldVal) => {
          if (newVal !== oldVal) {
            const subCategoriesByValue = subCategories && !!subCategories[newVal] ? subCategories[newVal] : [];
            const subCategory = subCategoriesByValue.length === 1 ? subCategoriesByValue[0].key : null;
            setTimeout(() => {
              form.change('subCategory', subCategory);
            }, 150)
          }
        }}
      </OnChange>

      {!(categoryVal && subCategories[categoryVal])
        ? null : (
          <FieldSelect
            id="subCategory"
            name="subCategory"
            className={css.generalField}
            label={subCategoryLabel}
            validate={subCategoryRequired}
          >
            <option disabled value="">{subCategoryPlaceholder}</option>
            {subCategories[categoryVal].map(subCategory => (
              <option value={subCategory.key} key={subCategory.key}>
                {intl.formatMessage({ id: subCategory.labelId })}
              </option>
            ))}
          </FieldSelect>
        )}
    </>
  ) : null;
};

export default CustomCategorySelectFieldMaybe;
